import L from "leaflet";
import icon from "./iconLocation.png";

const IconLocation = L.icon({
  iconUrl: icon,
  iconSize: [35, 35],
});

export default IconLocation;
